import script from "./format.vue?vue&type=script&lang=js&setup=true"
export * from "./format.vue?vue&type=script&lang=js&setup=true"

import "./format.vue?vue&type=style&index=0&id=74bfbc3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74bfbc3e"]])

export default __exports__